import { render, staticRenderFns } from "./CreatePerformanceDialog.vue?vue&type=template&id=99cde318&scoped=true&"
import script from "./CreatePerformanceDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePerformanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatePerformanceDialog.vue?vue&type=style&index=0&id=99cde318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cde318",
  null
  
)

export default component.exports